import { render, staticRenderFns } from "./ChatbotSandbox.vue?vue&type=template&id=142aa882&scoped=true"
import script from "./ChatbotSandbox.vue?vue&type=script&lang=js"
export * from "./ChatbotSandbox.vue?vue&type=script&lang=js"
import style0 from "./ChatbotSandbox.vue?vue&type=style&index=0&id=142aa882&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142aa882",
  null
  
)

export default component.exports